import { createContext } from 'react';

const DialogContext = createContext();

export default DialogContext;